import {constants} from '@neosvoc/nv-platform-core-common';
import cloneDeep from 'lodash/cloneDeep';

const regenerateRowIds = (rows) => {
    const newRows = cloneDeep(rows);
    newRows.forEach((row, index) => row.id = `${index + 1}`);
    return newRows;
};

const rowIdsRegenerators = {
    [constants.EDITOR_TEMPLATES.STRING_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.TEXT_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.NUMBER_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.NUMBER_2]: (item) => item,
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1]: (item) => Object.assign(item, {rows: regenerateRowIds(item.rows)}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2]: (item) => Object.assign(item, {rows: regenerateRowIds(item.rows)}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3]: (item) => Object.assign(item, {rows: regenerateRowIds(item.rows)}),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT]: (item) => item,
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2]: (item) => item,
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3]: (item) => item,
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4]: (item) => item,
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2]: (item) => item,
    [constants.EDITOR_TEMPLATES.BATTERY_1]: (item) => Object.assign(item, {rows: regenerateRowIds(item.rows)}),
    [constants.EDITOR_TEMPLATES.BATTERY_2]: (item) => Object.assign(item, {rows: regenerateRowIds(item.rows)}),
    [constants.EDITOR_TEMPLATES.DATE_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.IMAGE_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.GEO_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER]: (item) => item,
    [constants.EDITOR_TEMPLATES.RANK_1]: (item) => item,
    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2]: (item) => item,
};

export default rowIdsRegenerators;
